import { Injectable } from '@angular/core';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class SsrBrowserContextService {
    isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
}